
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useOrganizationScoping } from "./useOrganizationScoping";

export const useQuotes = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { buildQuoteFilter } = useOrganizationScoping();

  const query = useQuery({
    queryKey: ['quotes', bookingId],
    queryFn: async () => {
      if (!bookingId) return [];
      
      console.log('[USE-QUOTES] Fetching quotes for booking:', bookingId);
      
      let query = supabase
        .from('quotes')
        .select('*')
        .eq('booking_id', bookingId);
      
      // Apply organization scoping for quotes
      query = buildQuoteFilter(query);
      
      const { data, error } = await query.order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching quotes:', error);
        throw error;
      }

      console.log('[USE-QUOTES] Fetched quotes:', data?.length || 0);
      return data || [];
    },
    enabled: !!bookingId,
  });

  const invalidateQuotes = () => {
    console.log('[USE-QUOTES] Invalidating quotes cache for booking:', bookingId);
    queryClient.invalidateQueries({ queryKey: ['quotes', bookingId] });
  };

  return {
    ...query,
    invalidateQuotes
  };
};
